import { useState } from 'react';
import { notification } from 'tea-component';
import { reportOperationLog } from '@gp/services/global';
import { downloadProjectList } from '../service';
import { downloadFileByBlob, stream2Object } from '@gp/utils/common';
import { ALL_REPORT_OPERATION_LOG } from '@gp/constants/operationLogParams';

import type { IRecord } from '@gp/types/global';

const mergeProjectsAndProjectDetailsDownloadCfgs = (
  projects?: string[] | null,
  projectDetails?: string[] | null,
): string[] => {
  const validCfgs = [projects, projectDetails].filter((item) => Array.isArray(item) && item.length > 0) as string[][];
  return validCfgs.reduce((acc, cur) => [...acc, ...cur]);
};

export default function useDownload(props: { fetchParams: IRecord<any>; setIsDownloading: React.Dispatch<boolean> }) {
  const { fetchParams, setIsDownloading } = props;

  const [downloadModalRes, setDownloadModalRes] = useState<IRecord<any>>({});

  const handleDownload = async () => {
    try {
      let isFinishDownload = false;
      setIsDownloading(true);
      try {
        const { fileType, projects, projectDetail, latestGR, stakeholder, tech } = downloadModalRes || {};
        const { stream, fileName } = await downloadProjectList({
          file_type: Number(fileType) || 2,
          project_list_req: fetchParams,
          project_detail: mergeProjectsAndProjectDetailsDownloadCfgs(projects, projectDetail),
          last_gr: latestGR,
          stakeholder,
          tech,
        });
        downloadFileByBlob(stream, fileName);
      } catch (res: any) {
        const resData = await stream2Object(res?.data);
        throw new Error(resData?.msg || '');
      } finally {
        isFinishDownload = true;
      }
      if (isFinishDownload) {
        reportOperationLog(
          // @ts-ignore
          downloadModalRes?.fileType == '1'
            ? ALL_REPORT_OPERATION_LOG.ALL_PROJECTS_CSV_DOWNLOAD_SUBMIT
            : ALL_REPORT_OPERATION_LOG.ALL_PROJECTS_EXCEL_DOWNLOAD_SUBMIT,
          'button',
        );
        notification.success({
          unique: true,
          description: 'Download successfully',
        });
      }
    } catch (error: any) {
      console.warn(`all projects list download error: ${error?.message || ''}`);
      notification.error({
        unique: true,
        description: 'Download failed',
      });
    } finally {
      setIsDownloading(false);
    }
  };

  return {
    downloadModalRes,
    setDownloadModalRes,
    handleDownload,
  };
}
